module.exports = {
  BOH_TRANSACTIONS_DELETE_REQUEST: 'BOH_TRANSACTIONS_DELETE_REQUEST',
  BOH_TRANSACTIONS_DELETE_SUCCESS: 'BOH_TRANSACTIONS_DELETE_SUCCESS',
  BOH_TRANSACTIONS_DELETE_FAILURE: 'BOH_TRANSACTIONS_DELETE_FAILURE',
};
